
import { AppAnnotation4Answers } from "@/interfaces/candidate/canidate_assessments";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import Vue, { PropType } from "vue";
export default Vue.extend({
  name: "AppAnnotationPart4",
  data() {
    return {
      options: [] as AppAnnotation4Answers[]
    };
  },
  props: {
    question: {
      type: Object as PropType<AppAssessments.AssessmentQuestionnaires>,
      required: true
    }
  },
  mounted() {
    if (
      this.question.question_options &&
      this.question.question_options.responses
    ) {
      for (let res of this.question.question_options.responses) {
        if (!res.content || !res.title) continue;
        this.options.push({
          answer: "",
          title: res.title,
          content: res.content
        });
      }
    }
  },
  methods: {
    submit_ans() {
      this.$emit("annotation-4", this.options);
    },
    event_cancellation(event: any) {
      event.preventDefault();
    }
  }
});
